import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
    DataService,
    FormInputComponent,
    RelationCustomFieldConfig,
    SharedModule,
} from '@vendure/admin-ui/core';
import { Observable } from 'rxjs';

@Component({
    selector: 'vdr-tax-rate-selector',
    template: `
        <div *ngIf="formControl.value as taxRate">
            <vdr-chip>{{ taxRate.name }}</vdr-chip>
            {{ taxRate.name }}
            <a [routerLink]="['/settings', 'tax-rates', taxRate.id]">
                <clr-icon shape="link"></clr-icon>
            </a>
        </div>
        <select [formControl]="formControl" [compareWith]="compareFn">
            <option [ngValue]="null">Select a tax rate...</option>
            <option *ngFor="let item of taxRates$ | async" [ngValue]="item">
                {{ item.name }} {{ item.value }} %
            </option>
        </select>
    `,
    standalone: true,
    imports: [SharedModule],
})
export class TaxRateSelector implements OnInit, FormInputComponent<RelationCustomFieldConfig> {
    readonly: boolean;
    config: RelationCustomFieldConfig;
    formControl: FormControl;
    taxRates$: Observable<any[]>;

    constructor(private dataService: DataService) {}

    ngOnInit() {
        this.taxRates$ = this.dataService.settings.getTaxRatesSimple().mapSingle(data => data.taxRates.items);
    }

    compareFn(item1: { id: string } | null, item2: { id: string } | null): boolean {
        return item1 && item2 ? item1.id === item2.id : item1 === item2;
    }
}
